import { combineReducers } from 'redux';
import app from './app';
import setting from './setting';
import user from './user';
import fantasy_cricket from './fantasy_cricket';
import fantasy_substitute from './fantasy_substitute';
import fantasy_kabaddi from './fantasy_kabaddi';
import screens_data from './screens_data';
import fantasy_football from './fantasy_football';
import fantasy_yes_no from './fantasy_yes_no';
import minigames from './minigames';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import milestones from './milestones';
const persistConfig = {
  whitelist: [
    'user',
    'fantasy_cricket',
    'fantasy_substitute',
    'fantasy_kabaddi',
    'fantasy_yes_no',
    'fantasy_football',
    'milestones',
    'minigames'
  ],
  key: 'primary',
  storage
};

const appPersistConfig = {
  whitelist: [
    'serverType',
    'baseUrlsObj',
    'branchData',
    'bannerList',
    'sportsFactsData',
    'popupData',
    'bannerPopupLastShowingTime',
    'currentLocation',
    'currentLocationState',
    'lastBuildCheckTime',
    'language'
  ],
  key: 'app',
  storage
};

const settingPersistConfig = {
  whitelist: ['sound', 'themeType'],
  key: 'setting',
  storage
};

let rootReducer = combineReducers({
  app: persistReducer(appPersistConfig, app),
  setting: persistReducer(settingPersistConfig, setting),
  user,
  fantasy_cricket,
  fantasy_substitute,
  fantasy_kabaddi,
  screens_data,
  fantasy_yes_no,
  fantasy_football,
  minigames,
  milestones
});

let persistedReducer = persistReducer(persistConfig, rootReducer);
export default persistedReducer;
